import { Reducer } from "redux";

import { SlotsActionDispatchTypes } from "../models/dispatchTypes/Referral";
import { SlotsDispatchTypes } from "../constants/Referral";
import { SlotsResponse } from "../models/api/Referral";

const initialState: SlotsResponse = {
  loading: false,
  response: {
    currentStartDate: "",
    currentEndDate: "",
    nextStartDate: "",
    nextEndDate: "",
  },
  error: null,
};

const SlotsReducer: Reducer<
SlotsResponse,
  SlotsActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SlotsDispatchTypes.SLOTS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SlotsDispatchTypes.SLOTS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SlotsDispatchTypes.SLOTS_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }case SlotsDispatchTypes.SLOTS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SlotsReducer;
